module.exports = __webpack_public_path__ + "1cfcb6471f35362b84f460466ff0177a.png";